import { createAction, props } from '@ngrx/store';

export const promotionId = createAction('promotionId', props<{ data: any }>());
export const fileUrl = createAction('fileUrl', props<{ data: any }>());
